import { NgModule } from '@angular/core';
import { NZ_ICONS } from 'ng-zorro-antd/icon';

import {
  CheckCircleOutline,
  CloseOutline,
  BellOutline,
  BarChartOutline,
  CalendarOutline,
  ClockCircleOutline,
  ControlOutline,
  DownOutline,
  HourglassOutline,
  AimOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  FormOutline,
  DashboardOutline,
  DeleteOutline,
  ContainerOutline,
  EditOutline,
  FolderOpenOutline,
  FileProtectOutline,
  FundOutline,
  MoreOutline,
  PlusOutline,
  MinusOutline,
  ProfileOutline,
  GlobalOutline,
  LogoutOutline,
  SearchOutline,
  SettingOutline,
  NotificationOutline,
  AlertOutline,
  ScheduleOutline,
  CarOutline,
  IdcardOutline,
  CustomerServiceOutline,
  InboxOutline,
  ThunderboltOutline,
  FileDoneOutline,
  ApartmentOutline,
  EnvironmentOutline,
  FieldTimeOutline,
  DollarOutline,
  StarOutline,
  StopOutline,
  TeamOutline,
  WarningOutline,
  InfoCircleOutline,
  DeploymentUnitOutline,
  SoundOutline,
  ArrowRightOutline,
  BranchesOutline,
  EyeInvisibleOutline,
  EyeOutline,
  LockOutline,
  MailOutline,
  MoneyCollectOutline,
  PhoneOutline,
  RiseOutline,
  ReloadOutline,
  SaveOutline,
  TagsOutline,
  UserOutline,
  UserSwitchOutline,
} from '@ant-design/icons-angular/icons';

const icons = [
  MenuFoldOutline,
  MenuUnfoldOutline,
  BellOutline,
  CloseOutline,
  BarChartOutline,
  CalendarOutline,
  ClockCircleOutline,
  HourglassOutline,
  ControlOutline,
  AimOutline,
  DashboardOutline,
  DeleteOutline,
  EditOutline,
  ContainerOutline,
  FileProtectOutline,
  FormOutline,
  FolderOpenOutline,
  FundOutline,
  TeamOutline,
  CheckCircleOutline,
  StopOutline,
  PlusOutline,
  MinusOutline,
  MoreOutline,
  ProfileOutline,
  GlobalOutline,
  LogoutOutline,
  SearchOutline,
  SettingOutline,
  DownOutline,
  NotificationOutline,
  AlertOutline,
  ScheduleOutline,
  CarOutline,
  IdcardOutline,
  CustomerServiceOutline,
  InboxOutline,
  ThunderboltOutline,
  FileDoneOutline,
  ApartmentOutline,
  EnvironmentOutline,
  FieldTimeOutline,
  DollarOutline,
  StarOutline,
  WarningOutline,
  InfoCircleOutline,
  DeploymentUnitOutline,
  SoundOutline,
  ArrowRightOutline,
  BranchesOutline,
  EyeInvisibleOutline,
  EyeOutline,
  LockOutline,
  MailOutline,
  MoneyCollectOutline,
  PhoneOutline,
  RiseOutline,
  ReloadOutline,
  SaveOutline,
  TagsOutline,
  UserOutline,
  UserSwitchOutline,
];

@NgModule({
  providers: [
    { provide: NZ_ICONS, useValue: icons }
  ]
})
export class IconsProviderModule {
}
